import React, { useCallback, useMemo, useRef } from 'react'
import { AgGridReact } from 'ag-grid-react'
import { AllCommunityModule, ModuleRegistry } from 'ag-grid-community';
import '../../assets/css/DataTable.css'
import { FaDownload } from 'react-icons/fa';
import { Download } from 'lucide-react';
ModuleRegistry.registerModules([AllCommunityModule]);


export default function DataTable(props) {
    const gridRef = useRef()

    const defaultColDef = useMemo(() => ({
        // flex: 1,
        minWidth: 150,
        resizable: true,
        sortable: true,
        filter: true,
    }), [])

    const paginationNumberFormatter = useCallback((params) => {
        return (
            params.value.toLocaleString()
        )
    }, []);

    const onFirstDataRendered = useCallback((params) => {
        gridRef.current.api.autoSizeAllColumns();
    }, []);

    // const onGridSizeChanged = useCallback((params) => {
    //     gridRef.current.api.sizeColumnsToFit();
    // }, []);

    const onPageSizeChanged = useCallback(() => {
        var value = document.getElementById('page-size').value;
        gridRef.current.api.paginationSetPageSize(Number(value));
    }, []);

    const onFilterTextBoxChanged = useCallback(() => {
        gridRef.current.api.setGridOption(
            "quickFilterText",
            document.getElementById("filter-text-box").value,
        );
    }, []);

    // const onBtnExport = useCallback(() => {

    //     gridRef.current.api.exportDataAsCsv();
    //     const today = new Date();
    //     const formattedDate =
    //         today.getDate().toString().padStart(2, '0') + '-' +
    //         (today.getMonth() + 1).toString().padStart(2, '0') + '-' +
    //         today.getFullYear();

    //     gridRef.current.api.exportDataAsCsv({
    //         fileName: `Link Analysis-${formattedDate}.csv`
    //     });
    // }, []);

   const onBtnExport = useCallback(() => {
          var params = {
              columnKeys: props.exportcolumn
          };
          gridRef.current.api.exportDataAsCsv(params);
      }, []);

    const onSelectionChanged = useCallback((params) => {

        const selectedData = gridRef.current.api.getSelectedRows();
        props.value(props.field, selectedData)

    }, []);
    return (
        <>
            <div className="row mb-3 align-items-center">
                <div className="col-8 col-sm-6 col-md-4">
                    {props?.search ? (
                        <div className='data-table-extensions-filter'>
                            <input
                                type="text"
                                id="filter-text-box"
                                placeholder="Search..."
                                className="form-control form_input"
                                onInput={onFilterTextBoxChanged}
                            />
                        </div>
                    ) : ''}
                </div>
                <div className="col-4 col-sm-6 col-md-8 text-end">
                    {props?.excel ? (
                        <button
                            type='button'
                            className='btn btn-primary d-inline-flex align-items-center justify-content-center'
                            style={{ cursor: 'pointer', padding: '8px 12px' }}
                            onClick={onBtnExport}
                        >
                            <Download size={20} />
                        </button>
                    ) : ''}
                </div>
            </div>
            <div className="ag-theme-alpine mt-2" style={{ height: props && props.height ? props.height : '70vh', width: '100%' }}>
                <AgGridReact
                    ref={gridRef}
                    rowData={props.rowData ? props.rowData : ''}
                    columnDefs={props.columnDefs ? props.columnDefs : ''}
                    defaultColDef={defaultColDef}
                    pagination={true}
                    check={props.check}
                    // paginationPageSize={10}
                    paginationNumberFormatter={paginationNumberFormatter}
                    onFirstDataRendered={onFirstDataRendered}
                    // onGridSizeChanged={onGridSizeChanged}
                    rowHeight={props.rowHeight ? props.rowHeight : ''}
                    rowSelection={props.check ? props.check : ''}
                    suppressRowClickSelection={props.selection ? true : ''}
                    onSelectionChanged={props.selection ? onSelectionChanged : ''}
                />

            </div >
        </>
    )
}
